import { render, staticRenderFns } from "./PromtCreate.vue?vue&type=template&id=67f9c015"
import script from "./PromtCreate.vue?vue&type=script&lang=js"
export * from "./PromtCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports